'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _provideActiveInfo = require('./provideActiveInfo');

var _provideActiveInfo2 = _interopRequireDefault(_provideActiveInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  validator: _propTypes.func,
  validateBeforeTouched: _propTypes.bool,
  onFocus: _propTypes.func,
  onBlur: _propTypes.func
}), (0, _injectProps2.default)({
  value: _propTypes.any
}),

// will trigger render on every focus and blur
// because focus and blur may change render result
_provideActiveInfo2.default, // => isTouched
(0, _withProps2.default)(function (_ref) {
  var isTouched = _ref.isTouched,
      validateBeforeTouched = _ref.validateBeforeTouched,
      validator = _ref.validator,
      value = _ref.value;

  if (validator && (isTouched || validateBeforeTouched)) {
    return { isInvalid: !!validator(value) };
  }

  return {};
}), (0, _exposeProps2.default)(['isInvalid', 'onFocus', 'onBlur']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'validateValue');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/validateValue.js
// module id = 1635
// module chunks = 0